import { render, staticRenderFns } from "./FormBookPurchases.vue?vue&type=template&id=60dc923e&scoped=true&"
import script from "./FormBookPurchases.vue?vue&type=script&lang=js&"
export * from "./FormBookPurchases.vue?vue&type=script&lang=js&"
import style0 from "./FormBookPurchases.vue?vue&type=style&index=0&id=60dc923e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dc923e",
  null
  
)

export default component.exports